angular.module('Const').constant('TypeStatusConsts', {
    jobType: {
        p2p: 'P2P',
        delivery: 'Delivery',
        pickuponly: 'Pickup Only',
        P2P: 'P2P',
        DELIVERY: 'Delivery',
        PICKUPONLY: 'Pickup Only'
    },
    jobTypeValue: {
        p2p: 'P2P',
        delivery: 'DELIVERY',
        pickUpOnly: 'PICKUPONLY'
    },
    jobStatuses: {
        unassigned: 'Unassigned',
        forapproval: 'For Approval',
        pending: 'Pending',
        accepted: 'Accepted',
        received: 'Received',
        inprogress: 'In Progress',
        delivered: 'Delivered',
        failed: 'Failed',
        rejected: 'Rejected',
        notyetstarted: 'Not Yet Started'
    },
    jobStatusesValue: {
        unassigned: 'UNASSIGNED',
        forapproval: 'FORAPPROVAL',
        pending: 'PENDING',
        accepted: 'ACCEPTED',
        received: 'RECEIVED',
        inprogress: 'INPROGRESS',
        delivered: 'DELIVERED',
        failed: 'FAILED',
        rejected: 'REJECTED',
        notyetstarted: 'NOTYETSTARTED'
    }
});



// WEBPACK FOOTER //
// ./js/consts/TypeStatusConsts.js